import { render, staticRenderFns } from "./Advanced.vue?vue&type=template&id=604d2fcb&scoped=true&"
import script from "./Advanced.vue?vue&type=script&lang=js&"
export * from "./Advanced.vue?vue&type=script&lang=js&"
import style0 from "./Advanced.vue?vue&type=style&index=0&id=604d2fcb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604d2fcb",
  null
  
)

export default component.exports